export const finland = {
  slug: "finland",
  name: "Finland",
  flag: "🇫🇮",
  tagline: "World-Class Innovation, Research & Student-Centric Education",

  // Updated accessible image
  heroImg:
    "https://images.unsplash.com/photo-1519865885898-a54a6f2c7eea?q=80&w=1600&auto=format&fit=crop",

  accentColor: "#0D5EAF",

  students: "20+",
  avgTuition: "€6,000 – €18,000 / year",
  avgLiving: "€700 – €1,200 / month",
  workPermit: "2 Years Post-Study",
  ieltsReq: "IELTS 6.0 – 6.5",
  intakeMonths: ["January", "August"],

  overview:
    "Finland has become one of Europe’s fastest-growing destinations for international students due to its globally recognized education system, innovation-driven economy, safe society, and high quality of life. Finnish universities focus heavily on practical learning, research, sustainability, and industry collaboration. Students benefit from modern campuses, advanced technology ecosystems, startup opportunities, and excellent post-study work options in fields such as IT, AI, engineering, business, renewable energy, and healthcare.",

  highlights: [
    "Globally respected universities and applied sciences institutions",
    "Strong demand for tech, AI, engineering, and healthcare professionals",
    "Safe, peaceful, and student-friendly environment",
    "2-year post-study residence permit for job search",
    "High-quality research and innovation ecosystem",
    "Affordable living compared to many Western European countries",
    "English-taught Bachelor's and Master's programs",
    "Excellent work-life balance and sustainability culture",
  ],

  whyChoose: [
    {
      icon: "🎓",
      title: "Globally Recognized Education",
      desc:
        "Finnish universities are known for academic excellence, research quality, and practical learning approaches.",
    },
    {
      icon: "💻",
      title: "Technology & Innovation Hub",
      desc:
        "Finland has a strong startup ecosystem with opportunities in AI, software, gaming, and engineering sectors.",
    },
    {
      icon: "🌍",
      title: "Safe & Student-Friendly",
      desc:
        "Consistently ranked among the happiest and safest countries in the world for international students.",
    },
    {
      icon: "📋",
      title: "2-Year Post-Study Permit",
      desc:
        "Graduates can stay in Finland for up to 2 years to search for jobs and build their careers.",
    },
    {
      icon: "🌲",
      title: "High Quality of Life",
      desc:
        "Clean cities, fresh environment, modern infrastructure, and excellent public services.",
    },
    {
      icon: "🤝",
      title: "Career & PR Opportunities",
      desc:
        "Students can transition to work-based residence permits and long-term settlement pathways.",
    },
  ],

  topCourses: [
    "Computer Science & AI",
    "Data Science",
    "Information Technology",
    "Game Development",
    "Mechanical Engineering",
    "Electrical Engineering",
    "Business Analytics",
    "International Business",
    "Renewable Energy",
    "Healthcare & Nursing",
  ],

  scholarships: [
    "University tuition fee waivers",
    "Early-bird scholarships",
    "Merit-based scholarships",
    "Partial and full tuition reductions",
    "Performance-based continuation scholarships",
  ],

  workOpportunities: {
    partTime:
      "International students can work up to 30 hours/week during studies.",
    averagePay: "€10 – €18 per hour",
    sectors: [
      "IT & Software",
      "Restaurants & Hospitality",
      "Retail",
      "Warehousing",
      "Research Assistantships",
      "Delivery & Logistics",
    ],
  },

  visaRequirements: [
    "Valid Passport",
    "University Offer Letter",
    "Proof of Tuition Payment",
    "Proof of Funds",
    "Health Insurance",
    "Academic Documents",
    "English Proficiency Proof",
  ],

  process: [
    {
      step: "01",
      title: "Choose University & Program",
      desc:
        "Select a suitable Bachelor's or Master's programme from Finnish universities.",
    },
    {
      step: "02",
      title: "Apply via Studyinfo",
      desc:
        "Submit your application online through Finland’s centralized admission portal.",
    },
    {
      step: "03",
      title: "Entrance Exam / Interview",
      desc:
        "Some universities may conduct online entrance tests or interviews.",
    },
    {
      step: "04",
      title: "Receive Admission Offer",
      desc:
        "After evaluation, universities issue admission and scholarship decisions.",
    },
    {
      step: "05",
      title: "Apply for Residence Permit",
      desc:
        "Submit your student residence permit application with financial and academic documents.",
    },
    {
      step: "06",
      title: "Fly to Finland",
      desc:
        "Complete municipal registration and begin your student journey in Finland.",
    },
  ],

  universities: [
    "helsinki",
    "aalto",
    "tampere",
    "oulu",
    "turku",
    "lut",
    "jyvaskyla",
    "abo-akademi",
  ],

  cities: [
    "Helsinki",
    "Espoo",
    "Tampere",
    "Turku",
    "Oulu",
    "Lappeenranta",
  ],

  stats: [
    { n: "20+", label: "Students Placed" },
    { n: "€6k", label: "Starting Tuition / Year" },
    { n: "92%", label: "Visa Success Rate" },
    { n: "2yr", label: "Post-Study Work Permit" },
  ],

  faqs: [
    {
      q: "Can international students work while studying in Finland?",
      a:
        "Yes, students can work up to 30 hours per week during academic sessions.",
    },
    {
      q: "Is IELTS mandatory for Finland?",
      a:
        "Most universities require IELTS, TOEFL, or equivalent English proficiency proof.",
    },
    {
      q: "Are scholarships available in Finland?",
      a:
        "Yes, many universities provide partial or full tuition scholarships for international students.",
    },
    {
      q: "Can students stay after graduation?",
      a:
        "Yes, Finland provides a 2-year post-study residence permit for job searching.",
    },
  ],
};